import { createAsyncThunk } from "@reduxjs/toolkit";
import { setBasket } from "../basket";
import { setSelectedShipping } from "../../selection";
const calculateBasketDiscountDeals = async (response) => {
    const DELIVERYDEAL = "FREE-SHIPPING";
    const APPLY_TO_BASKET = "BASKET";
    response.content["has_delivery_fee_deal"] = false;
    for (const deal of response.content.deals) {
        if (deal.delivery_fee && deal.apply_to == APPLY_TO_BASKET) {
            // change the delivery fee to be the discount delivery fee
            response.content["delivery_fee_deal"] = deal.delivery_fee;
            response.content["has_delivery_fee_deal"] = true;
        }
    }
    return response;
};
const calculateTotalProductDiscountDeals = async (response) => {
    if (response.content.product_list.length != 0) {
        let dealTotal = 0;
        for (let index = 0; index < response.content.product_list.length; index++) {
            const product = response.content.product_list[index];
            if (product?.deal) {
                const deal = product.deal;
                dealTotal = +parseFloat(deal.discount);
                return dealTotal;
            }
        }
    }
    return 0;
};
const setVariationPriceForEachProduct = async (response) => {
    // Note - each prodct is returned with a price of 0.00 in the basket.
    // This is because the price of the product is the price of the variation.
    // Therefore, we need to add the price of the variation to the price of the product.
    await response.content.product_list.forEach((product) => {
        if (product.variations && product.variations.length > 0) {
            for (const variation of product.variations) {
                if (variation.variations[0].price) {
                    let price = parseFloat(variation.variations[0].price) + parseFloat(product.price);
                    response.content["product_list"] = response.content.product_list.map((x) => {
                        if (x._id == product._id) {
                            return {
                                ...x,
                                price: price.toFixed(2).toString(),
                            };
                        }
                        return x;
                    });
                }
            }
        }
    });
    return response;
};
const restoreSelectedShippingFromBasket = (basketContent, getState, dispatch) => {
    const state = getState();
    const currentSelection = state.selectionState?.selection?.selectedShipping;
    if (currentSelection)
        return;
    const rateEntry = basketContent?.extra_data?.find((entry) => entry?.name === "starshipit_rate");
    if (!rateEntry?.value)
        return;
    try {
        const parsed = typeof rateEntry.value === "string" ? JSON.parse(rateEntry.value) : rateEntry.value;
        dispatch(setSelectedShipping(parsed));
    }
    catch {
        // ignore malformed rate entry
    }
};
export const calculate_basket_thunk = createAsyncThunk("basket/calculate_basket_thunk", async (response, { dispatch, getState }) => {
    const basketResponse = await calculateBasketDiscountDeals(response);
    const dealTotal = await calculateTotalProductDiscountDeals(basketResponse);
    basketResponse.content["total_product_deals"] = dealTotal.toString();
    await setVariationPriceForEachProduct(basketResponse);
    dispatch(setBasket(basketResponse.content));
    restoreSelectedShippingFromBasket(basketResponse.content, getState, dispatch);
    return basketResponse;
});
